import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IMAGES } from "../../../assets/images/images";
import { useNavigate } from "react-router-dom";
import {
  resendOtp,
  verifyOtp,
} from "../../../utility/apiServices/userServices";
import {
  UseridState,
  emailState,
} from "../../../utility/globle/recoil/atom";
import { useRecoilValue } from "recoil";
import { encrypt } from "../../../utility/local/functions/crypto";
import { setLocalStorage } from "../../../utility/local/functions/setlocalStorage";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";


const PropertyOwnerOTP = () => {
  const navigate = useNavigate();
  const id = useRecoilValue(UseridState);
  const email = useRecoilValue(emailState);
  const { t, i18n } = useTranslation();
  console.log("id,email :", id, email);
  useEffect(() => {
    if (!id || !email || id === "" || email === "") {
      navigate("/propertyowner-signup");
    }
  }, [id, email, navigate]);

  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [messageType, setmessageType] = useState(false);
  const [Loading, setLoading] = useState(false);

  const resendNewOtp = async () => {
    const resendOtpresponse = await resendOtp({ userId: id, email });
    if (resendOtpresponse?.status) {
      setmessageType("success");
      setMessage(resendOtpresponse?.message);
      setShowMessage(true);
    } else {
      setmessageType("error");
      setMessage(resendOtpresponse?.message);
      setShowMessage(true);
    }
  };

  const VerifyUserOtp = async () => {
    setLoading(true);
    if (otp.length === 6) {
      const verifyOtpresponse = await verifyOtp({ userId: id, otp });
      if (verifyOtpresponse.status && !verifyOtpresponse?.user?.is_influencer) {
        setLocalStorage(
          verifyOtpresponse.accessToken,
          verifyOtpresponse.refreshToken,
          verifyOtpresponse?.user
        );
        navigate("/");
      } else if (
        verifyOtpresponse?.status &&
        verifyOtpresponse?.user?.status === "pending" &&
        verifyOtpresponse?.user?.is_influencer
      ) {
        Swal.fire({
          icon: "success",
          text: t("otp.success_message"),
          confirmButtonText: t("otp.ok_button"),
        });
        navigate("/");
      } else {
        setmessageType("error");
        setMessage(verifyOtpresponse?.message);
        setShowMessage(true);
      }
    } else {
      setmessageType("error");
      setMessage(t("otp.invalid_otp"));
      setShowMessage(true);
    }
    setLoading(false);
  };

  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <Form>
                <h1>{t("otp.verify_otp")}</h1>
                <p className="para">
                  {t("otp.enter_otp_message", { email: email || "" })}
                </p>

                <div className="otpBox">
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderInput={(props) => <input {...props} type="tel" inputMode="numeric" pattern="[0-9]*" />}
                  />
                </div>

                <div className="text-end">
                  <Link
                    className="forgotPassword textLineUnder"
                    onClick={resendNewOtp}
                  >
                    {t("otp.resend_otp")}
                  </Link>
                </div>

                <div className="text-start">
                  {showMessage && (
                    <div
                      className={
                        messageType == "success"
                          ? "successMessage"
                          : "errorMessage"
                      }
                    >
                      {message}
                    </div>
                  )}
                </div>
                <Button
                  // as={Link}
                  // to="/propertyowner-resetpassword"
                  className="btn btn-primary my-3 mb-4 my-mb-3 mb-md-3 my-lg-3 w-100"
                  onClick={() => VerifyUserOtp()}
                  disabled={Loading}
                >
                  {Loading ? <span className="spinner"></span> : t("otp.continue")}
                </Button>
                <p className="text-center">
                  {t("otp.back_to")}{" "}
                  <Link to="/propertyowner-signup" className="forgotPassword forgotPassword1">
                    {t("otp.signup")}
                  </Link>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyOwnerOTP;
